import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MetadataModel } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
@Component({
  selector: 'sp-select-export-metadata',
  templateUrl: './select-export-metadata.component.html',
  styleUrls: ['./select-export-metadata.component.scss'],
})
export class SelectExportMetadataComponent implements OnInit {
  mandatoryFields!: MetadataModel[];
  nonMandatoryFields!: MetadataModel[];
  allComplete = false;
  allSubFieldsComplete = false;
  resetViewFlag = false;

  constructor(
    public dialogRef: MatDialogRef<MetadataModel>,
    @Inject(MAT_DIALOG_DATA)
    public data: AnyType,
  ) {}

  ngOnInit(): void {
    this.mandatoryFields = JSON.parse(JSON.stringify(this.data.mandatoryField));
    this.nonMandatoryFields = JSON.parse(JSON.stringify(this.data.nonMandatoryField));
    this.allComplete = this.mandatoryFields !== null && this.mandatoryFields.every((t) => t.selected);
  }

  someComplete(): boolean {
    if (this.mandatoryFields === null) {
      return false;
    }
    return this.mandatoryFields.filter((t) => t.selected).length > 0 && !this.allComplete;
  }

  someSubFieldsComplete(fieldsGroup: MetadataModel[]): boolean {
    if (fieldsGroup === null) {
      return false;
    }
    const abc = fieldsGroup.filter((t) => t.selected).length > 0 && !this.allSubFieldsComplete;
    return abc;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.mandatoryFields === null) {
      return;
    }
    this.mandatoryFields.forEach((t) => (t.selected = completed));
  }

  selectField(selected: boolean, index: number, mandatoryFlag?: boolean) {
    if (mandatoryFlag) {
      this.mandatoryFields[index].selected = selected;
      this.allComplete = this.mandatoryFields.every((t) => t.selected);
    } else {
      this.nonMandatoryFields[index].selected = selected;
    }
  }

  setAllSubFields(completed: boolean, fieldsGroup: MetadataModel[], index: number) {
    this.allSubFieldsComplete = completed;
    this.nonMandatoryFields[index].selected = completed;
    if (fieldsGroup === null) {
      return;
    }
    fieldsGroup.forEach((t) => (t.selected = completed));
  }

  selectSubField(selected: boolean, index: number, fieldsGroup: MetadataModel[]) {
    fieldsGroup[index].selected = selected;
    this.allSubFieldsComplete = fieldsGroup.every((t) => t.selected);
  }

  resetView() {
    this.resetViewFlag = true;
    this.mandatoryFields.forEach((field) => {
      field.selected = true;
    });
    this.nonMandatoryFields.forEach((field) => {
      field.selected = false;
      if (field.formFieldGroup) {
        field.formFieldGroup.forEach((field) => {
          field.selected = false;
        });
      }
    });
    this.allComplete = true;
  }

  exportData() {
    const includedFields: Record<string, number> = {};
    const excludedFields: Record<string, number> = { owner: 0 };
    const buyoutRightsFields: string[] = [];

    [...this.mandatoryFields, ...this.nonMandatoryFields].forEach((field) => {
      if (field.customField) {
        if (field.selected) includedFields[field.formControlName] = 1;
        else excludedFields['customFields.' + field.formControlName] = 0;
      } else if (field.selected) {
        includedFields[field.formControlName] = 1;
      }
      if (field.formFieldGroup && field.formFieldGroup.length > 0) {
        field.formFieldGroup.forEach((subField) => {
          if (subField.selected) {
            buyoutRightsFields.push(subField.formControlName);
          }
        });
      }
    });

    const allFields: { excludedFields?: Record<string, number>; includedFields?: Record<string, number>; buyoutRightsFields?: string[] } = {
      excludedFields,
      includedFields,
      buyoutRightsFields,
    };
    this.dialogRef.close(allFields);
  }
}
